import { useQuery } from '@tanstack/react-query';
import { can, sujet, type ConsoleGroupe } from '@artosera/shared';
import { capturerPortee, exigerActuelle } from '../auth/identite.js';
import { empreinteDroitsGroupe } from '../auth/sujet.js';
import type { GroupeSession } from './types.js';
import { api, type AppelApi } from './client.js';
import { appelDeRequete, cleMetier } from './cles.js';

/** Console de groupe — `GET /v1/g/:slug/groupe` (M12), lecture seule. */
export const consoleGroupeApi = {
  lire: (galerie: string, depuis: string | null, appel?: AppelApi) =>
    api.get<ConsoleGroupe>(
      `/g/${encodeURIComponent(galerie)}/groupe${depuis ? `?depuis=${encodeURIComponent(depuis)}` : ''}`,
      { galerie, ...appel },
    ),
};

export function useConsoleGroupe(
  galerie: string,
  depuis: string | null,
  groupe: GroupeSession | null,
) {
  return useQuery({
    queryKey: cleMetier(galerie, 'groupe', empreinteDroitsGroupe(groupe), depuis),
    queryFn: async (contexte) => {
      const portee = capturerPortee();
      const donnees = await consoleGroupeApi.lire(galerie, depuis, appelDeRequete(contexte));
      exigerActuelle(portee);
      return donnees;
    },
    enabled: groupe !== null && can(sujet(groupe.role), 'group:read'),
    staleTime: 60_000,
  });
}
